const dnpInterstitialViewTemplate = `
<div>
    <div class="modal-header">
        <span class="site-logo-wrapper">
                <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" class="dnp-modal-logo" alt="site logo">
        </span>
        <span class="dnp-modal-tagline">{{ 'header.SavingsBillsManager' | translate }}</span>
    </div>
    <div class="modal-body margin-top-100">
        <hr>
        <p class="dnp-paragraph">{{ 'header.DNPModal.info1' | translate }} &ndash; {{ 'header.DNPModal.info2' | translate }}</p>
        <div class="modal-well with-background dnp-modal-well">
            <div class="row">
                <div class="col-xs-12"><i class="dnp-savings dnp-icon col-xs-2"></i><span class = "col-xs-10 dnp-icon-text"> {{ 'header.DNPModal.savings' | translate }}</span></div>
                <div class="col-xs-12 padding-top-100"><i class="dnp-bills dnp-icon col-xs-2"></i><span class = "col-xs-10  dnp-icon-text"> {{ 'header.DNPModal.bills' | translate }}</span></div>
                <div class="col-xs-12 padding-top-100" ><i class="dnp-arrow dnp-icon col-xs-2"></i><span class = "col-xs-10  dnp-icon-text"> {{ 'header.DNPModal.debts' | translate }}</span></div>
                <div class="col-xs-12 padding-top-100"><i class="dnp-scroll dnp-icon col-xs-2"></i><span class = "col-xs-10 dnp-icon-text"> {{ 'header.DNPModal.fees' | translate }}</span></div>
            </div>
        </div>
        <span class = "dnp-enroll-text">
            <span>{{ 'header.DNPModal.enroll-1' | translate }}</span>
            <em>{{ 'header.DNPModal.enroll-2' | translate }}</em>
            <span>{{ 'header.DNPModal.enroll-3' | translate }}</span>
        </span>
    </div>
    <div class="modal-footer">
        <hr>
        <p class="dnp-disclaimer-heading dnp-disclaimer-bold">{{ 'header.DNPModal.leavingEmpower' | translate }}</p>
        <div class="padding-bottom-100 row">
            <span  class = "text-align-left dnp-disclaimer-heading col-xs-12">
                <span>{{ 'header.DNPModal.disclaimer-1' | translate }}</span>
                <em>{{ 'header.DNPModal.disclaimer-2' | translate }}</em>
                <span>{{ 'header.DNPModal.disclaimer-3' | translate }}</span>
            </span>
        </div>
   
        <button class="btn btn-primary pull-right" ng-click="continueClick()">Continue</button>
    </div>
</div>
`;
export default dnpInterstitialViewTemplate;
